// extracted by mini-css-extract-plugin
export default {"title":"ExperimentTitle_title__ySzmD","loading":"ExperimentTitle_loading__+4KQI"};